export default __webpack_public_path__ + "static/media/linkedin.cc467502.svg";